import { each, filterL, go } from "fxjs/es";
import { DATA_KEY_STROKE_DASHARRAY, DATA_KEY_STROKE_WIDTH } from "./const.js";
import { Stroke } from "./Stroke.js";
export class StrokeSync {
  constructor({ el, SVGGraphicsElement, stroke }) {
    this._el = el;
    this._SVGGraphicsElement = SVGGraphicsElement;
    this._stroke = stroke;
  }
  setEl(el) {
    this._el = el;
    this.sync();
  }
  sync() {
    go(
      this._el.querySelectorAll(`[data-${DATA_KEY_STROKE_WIDTH}]`).values(),
      filterL((el) => el instanceof this._SVGGraphicsElement),
      each((el) => this._stroke.syncStrokeWidth(el))
    );
    go(
      this._el.querySelectorAll(`[data-${DATA_KEY_STROKE_DASHARRAY}]`).values(),
      filterL((el) => el instanceof this._SVGGraphicsElement),
      each((el) => this._stroke.syncStrokeDasharray(el))
    );
  }
}
